<template>
  <div
    class="fixed top-0 left-0 w-full h-full flex justify-center items-center"
    :style="{ zIndex: 9999999 }"
  >
    <div class="absolute top-0 left-0 w-full h-full bg-gray-500 opacity-75"></div>
    <div
      class="modal__source relative bg-white shadow-2xl p-4 rounded-xl overflow-y-auto"
      :style="{width: propWidth, height: propHeight}"
    >
      <div class="modal__header">
        <div class="modal__title">
          <slot name="header"></slot>
        </div>

        <div class="modal__close">
          <button @click="$emit('close-modal')">
            <i
              class="fas fa-times fa-lg"
              :class="{'text-red-500':isAdminPage,'text-gray-800': !isAdminPage}"
            ></i>
          </button>
        </div>
      </div>

      <div class="modal__content">
        <slot></slot>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  name: "ClientModal",
  props: {
    propWidth: {
      type: String,
      //   default: "94%",
    },
    propHeight: {
      type: String,
      default: "auto",
    },
    isAdminPage: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$emit("mountedModal");
  },
};
</script>
<style scoped>
.modal__source {
  display: flex;
  flex-direction: column;
  width: 760px;
  max-height: 99%;
}
.popupFace .modal__source {
  width: auto;
  height: auto;
  max-width: calc(100vw - 2rem);
  max-height: calc(100vh - 2rem);
  padding: 0.75rem;
}
.popupFace .modal__content {
  height: auto;
  overflow: hidden;
}
.modal__header {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}
.modal__title {
  font-size: 20px;
  color: #3b4450;
}
.modal__content {
  margin-top: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}
@media screen and (max-width: 1000px) {
  .modal__source {
    width: 94% !important;
  }
}
</style>
